/* @flow strict */


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.STATE = undefined;

const _react = require('react');

const _react2 = _interopRequireDefault(_react);

const _propTypes = require('prop-types');

const _propTypes2 = _interopRequireDefault(_propTypes);

const _createReactClass = require('create-react-class');

const _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) {
 return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
 const target = {};

for (const i in obj) {
 if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i];
} return target;
}

const STATE = exports.STATE = {
  LOADING: 'loading',
  DISABLED: 'disabled',
  SUCCESS: 'success',
  ERROR: 'error',
  NOTHING: ''
};

const ProgressButton = (0, _createReactClass2.default)({
  displayName: 'ProgressButton',

  propTypes: {
    classNamespace: _propTypes2.default.string,
    controlled: _propTypes2.default.bool,
    durationError: _propTypes2.default.number,
    durationSuccess: _propTypes2.default.number,
    form: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    onError: _propTypes2.default.func,
    onSuccess: _propTypes2.default.func,
    state: _propTypes2.default.oneOf(Object.keys(STATE).map((k) => {
      return STATE[k];
    })),
    type: _propTypes2.default.string,
    shouldAllowClickOnLoading: _propTypes2.default.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      classNamespace: 'pb-',
      controlled: false,
      durationError: 1200,
      durationSuccess: 500,
      onClick: function onClick() {},
      onError: function onError() {},
      onSuccess: function onSuccess() {},

      shouldAllowClickOnLoading: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      currentState: this.props.state || STATE.NOTHING
    };
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.state === this.props.state) {
      return;
    }
    switch (nextProps.state) {
      case STATE.SUCCESS:
        this.success();
        return;
      case STATE.ERROR:
        this.error();
        return;
      case STATE.LOADING:
        this.loading();
        return;
      case STATE.DISABLED:
        this.disable();
        return;
      case STATE.NOTHING:
        this.notLoading();
        return;
      default:
        return;
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this._timeout);
  },
  render: function render() {
    const _props = this.props;

        const className = _props.className;

        const classNamespace = _props.classNamespace;

        const children = _props.children;

        const type = _props.type;

        const form = _props.form;

        const durationError = _props.durationError;

        const durationSuccess = _props.durationSuccess;

        const onClick = _props.onClick;

        const onError = _props.onError;

        const onSuccess = _props.onSuccess;

        const state = _props.state;

        const shouldAllowClickOnLoading = _props.shouldAllowClickOnLoading;

        const controlled = _props.controlled;

        const containerProps = _objectWithoutProperties(_props, ['className', 'classNamespace', 'children', 'type', 'form', 'durationError', 'durationSuccess', 'onClick', 'onError', 'onSuccess', 'state', 'shouldAllowClickOnLoading', 'controlled']);

    containerProps.className = `${classNamespace  }container ${  this.state.currentState  } ${  className}`;
    containerProps.onClick = this.handleClick;
    return _react2.default.createElement(
      'div',
      containerProps,
      _react2.default.createElement(
        'button',
        { disabled: state === STATE.DISABLED, type, form, className: `${classNamespace  }button` },
        _react2.default.createElement(
          'span',
          null,
          children
        ),
        _react2.default.createElement(
          'svg',
          { className: `${classNamespace  }progress-circle`, viewBox: '0 0 41 41' },
          _react2.default.createElement('path', { d: 'M38,20.5 C38,30.1685093 30.1685093,38 20.5,38' })
        ),
        _react2.default.createElement(
          'svg',
          { className: `${classNamespace  }checkmark`, viewBox: '0 0 70 70' },
          _react2.default.createElement('path', { d: 'm31.5,46.5l15.3,-23.2' }),
          _react2.default.createElement('path', { d: 'm31.5,46.5l-8.5,-7.1' })
        ),
        _react2.default.createElement(
          'svg',
          { className: `${classNamespace  }cross`, viewBox: '0 0 70 70' },
          _react2.default.createElement('path', { d: 'm35,35l-9.3,-9.3' }),
          _react2.default.createElement('path', { d: 'm35,35l9.3,9.3' }),
          _react2.default.createElement('path', { d: 'm35,35l-9.3,9.3' }),
          _react2.default.createElement('path', { d: 'm35,35l9.3,-9.3' })
        )
      )
    );
  },
  handleClick: function handleClick(e) {
    if (this.props.controlled) {
      this.props.onClick(e);
      return true;
    }

    if ((this.props.shouldAllowClickOnLoading || this.state.currentState !== STATE.LOADING) && this.state.currentState !== STATE.DISABLED) {
      this.loading();
      const ret = this.props.onClick(e);

      this.handlePromise(ret);
    } else {
      e.preventDefault();
    }
  },
  handlePromise: function handlePromise(promise) {
    const _this = this;

    if (promise && promise.then && promise.catch) {
      promise.then(() => {
        _this.success();
      }).catch((err) => {
        _this.error(null, err);
      });
    }
  },
  loading: function loading() {
    this.setState({ currentState: STATE.LOADING });
  },
  notLoading: function notLoading() {
    this.setState({ currentState: STATE.NOTHING });
  },
  enable: function enable() {
    this.setState({ currentState: STATE.NOTHING });
  },
  disable: function disable() {
    this.setState({ currentState: STATE.DISABLED });
  },
  success: function success(callback, dontRemove) {
    const _this2 = this;

    this.setState({ currentState: STATE.SUCCESS });
    this._timeout = setTimeout(() => {
      if (!dontRemove) {
        _this2.setState({ currentState: STATE.NOTHING });
      }
      callback = callback || _this2.props.onSuccess;
      if (typeof callback === 'function') {
        callback();
      }
    }, this.props.durationSuccess);
  },
  error: function error(callback, err) {
    const _this3 = this;

    this.setState({ currentState: STATE.ERROR });
    this._timeout = setTimeout(() => {
      _this3.setState({ currentState: STATE.NOTHING });
      callback = callback || _this3.props.onError;
      if (typeof callback === 'function') {
        callback(err);
      }
    }, this.props.durationError);
  }
});

exports.default = ProgressButton;
